import TipoServicioService from 'src/modules/tipoServicio/tipoServicioService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'TIPOSERVICIO_VIEW';

const tipoServicioViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tipoServicioViewActions.FIND_STARTED,
      });

      const record = await TipoServicioService.find(id);

      dispatch({
        type: tipoServicioViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tipoServicioViewActions.FIND_ERROR,
      });

      getHistory().push('/tipo-servicio');
    }
  },
};

export default tipoServicioViewActions;
